import React from 'react'
import styles from './styles.module.scss'
import usePersistentExpansion from './usePersistentExpansion'
import { ReactComponent as LogoImg } from '../../../assets/images/logo.svg'
import { Link, useLocation } from 'react-router-dom'
import links from './Links'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

function Sidebar() {
  const { toggleExpand, expanded } = usePersistentExpansion()
  const { t } = useTranslation()
  const auth = useSelector((state) => state.auth)
  const { profile } = auth?.user || {}
  const isAdmin = profile?.role === 'admin'
  const location = useLocation()

  return (
    <div className={`${styles.container} ${!expanded ? styles.lite_view : ''}`}>
      <div className={styles.header}>
        <button className={styles.logo_button}>
          <LogoImg onClick={toggleExpand} />
        </button>
        <h2 className={styles.web_logo}>Dental Med</h2>
      </div>
      <ul className={styles.links_list}>
        {links(isAdmin, t)?.map((link) => {
          return (
            <li key={link.name} className={styles.links_list_li}>
              <Link
                to={link.path}
                className={`${styles.link} ${styles[`${link.path}`]} ${location.pathname?.includes(link.path) ? styles.active_link : ''}`}
              >
                {link.icon}
                <span className={styles.link_text}>{link.name}</span>
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
export default Sidebar
